/* esm.sh - @radix-ui/react-dropdown-menu@2.1.24 */
export * from "/*@radix-ui/react-dropdown-menu@2.1.24/esnext/react-dropdown-menu.mjs";
